/**
 * @generated SignedSource<<ee66483150d28f215f6de2d50dc9bd1a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type AssessmentStatus = "not_needed" | "incomplete" | "complete" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type eventGuestInlineFragment$data = {
  readonly id: string;
  readonly status: string;
  readonly assessmentStatus: AssessmentStatus | null;
  readonly contact: {
    readonly " $fragmentSpreads": FragmentRefs<"contactBaseInlineFragment">;
  };
  readonly salesOrders: ReadonlyArray<{
    readonly salesOrderItems: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"salesOrderItemInlineFragment">;
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"salesOrderBaseInlineFragment">;
  }>;
  readonly eventGuestAssessmentResponses: {
    readonly " $fragmentSpreads": FragmentRefs<"eventGuestAssessmentResponsesInlineFragment">;
  } | null;
  readonly " $fragmentType": "eventGuestInlineFragment";
};
export type eventGuestInlineFragment$key = {
  readonly " $data"?: eventGuestInlineFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"eventGuestInlineFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "eventGuestInlineFragment"
};

(node as any).hash = "c7aa08f3e4ab7c909ab68fceb56de7ed";

export default node;
